'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WelcomePage = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _reactRedux = require('react-redux');

var _navigation = require('program/frontend/actions/navigation');

var _RaisedButton = require('material-ui/RaisedButton');

var _RaisedButton2 = _interopRequireDefault(_RaisedButton);

var _flatIndex = require('program/flat-index');

var _vcenter = require('../components/vcenter');

var _avatar = require('./avatar.png');

var _avatar2 = _interopRequireDefault(_avatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var styles = {

  root: {
    position: "absolute",
    top: 64,
    left: 0,
    right: 0,
    bottom: 0,

    textAlign: "center",
    fontFamily: "Roboto, sans-serif",
    fontSize: 16,
    color: "#555"
  },

  header: {
    fontWeight: 300,
    color: "#887",
    marginBottom: 16,
    fontSize: 24
  },

  content: {
    maxWidth: 600,
    margin: 20
  }

};

var WelcomePage = _react2['default'].createClass({

  displayName: "WelcomePage",

  mixins: [_reactAddonsPureRenderMixin2['default']],

  handleStart: function handleStart() {

    this.props.dispatch((0, _navigation.navigateTo)("/v/" + encodeURIComponent(_flatIndex.flatIndex[0].videoId)));
  },
  render: function render() {

    return _react2['default'].createElement(
      'div',
      { style: styles.root },
      _react2['default'].createElement(
        _vcenter.VCenter,
        null,
        _react2['default'].createElement(
          'div',
          { style: styles.content },
          _react2['default'].createElement(
            'div',
            { style: styles.header },
            'Willkommen im SmartFarmer Online-Kurs!'
          ),
          _react2['default'].createElement(
            'p',
            null,
            'Werden Sie schnell und unkompliziert SmartFarmer Experte - wann und wo Sie wollen, im Tempo mit dem Sie sich am besten zurecht finden.'
          ),
          _react2['default'].createElement(
            'p',
            null,
            'Sie k\xF6nnen sich den kompletten Kurs in einem St\xFCck ansehen oder gezielt jene Kapitel aufrufen, die Sie gerade ben\xF6tigen. Machen Sie eine Pause, wann Sie m\xF6chten.'
          ),
          _react2['default'].createElement(
            'p',
            null,
            'Der Online-Kurs eignet sich sowohl f\xFCr Anf\xE4nger als auch als Nachschlagewerk f\xFCr Fortgeschrittene.'
          ),
          _react2['default'].createElement(
            'p',
            null,
            _react2['default'].createElement(_RaisedButton2['default'], {
              label: 'Kurs jetzt starten',
              onTouchTap: this.handleStart,
              primary: true
            })
          ),
          _react2['default'].createElement(
            'p',
            null,
            '...oder w\xE4hlen Sie ein Kapitel im \u2630 Men\xFC.'
          ),
          _react2['default'].createElement(
            'p',
            null,
            _react2['default'].createElement('img', { src: _avatar2['default'] })
          )
        )
      )
    );
  }
});

exports.WelcomePage = WelcomePage = (0, _reactRedux.connect)()(WelcomePage);

exports.WelcomePage = WelcomePage;


//////////////////
// WEBPACK FOOTER
// ./program/frontend/welcome/index.jsx
// module id = 971
// module chunks = 0